export class NotPremiumError extends Error {}
